import * as React from 'react';

interface ButtonProps {
  readonly onClick: any;
  readonly title: any;
  readonly style?: any;
  readonly className?: string;
}

class BelfiusButton extends React.PureComponent<ButtonProps> {
  render() {
    return (
      <button {...this.props}>{this.props.title}</button>
    );
  }
}

export { BelfiusButton };
